import { useTranslationLanguageWithoutRegion } from './useTranslationLanguageWithoutRegion';
import type { OrderItem } from 'store/Orders/types';

const INTERNAL = 'internal' as const;

type UseItemAddonDisplayNameArgs = {
  itemAddonsName: string;
  itemAddonsDisplayName: OrderItem['addons_display_names'];
};

export function useItemAddonDisplayName(): {
  getItemAddonDisplayName: ReturnType<typeof getItemAddonDisplayName>;
};
export function useItemAddonDisplayName(args: UseItemAddonDisplayNameArgs): {
  itemAddonDisplayName: string | undefined;
};
export function useItemAddonDisplayName(args?: UseItemAddonDisplayNameArgs) {
  const { lang } = useTranslationLanguageWithoutRegion();

  if (!args) {
    return {
      getItemAddonDisplayName: getItemAddonDisplayName({ lang }),
    };
  }

  const itemAddonDisplayName = getItemAddonDisplayName({ lang })(
    args.itemAddonsName,
    args.itemAddonsDisplayName,
  );

  return {
    itemAddonDisplayName,
  };
}

export const getItemAddonDisplayName =
  (dep: { lang: string }) =>
  (
    itemAddonsName: string,
    itemAddonsDisplayName: OrderItem['addons_display_names'],
  ) => {
    return itemAddonsDisplayName?.[itemAddonsName]?.[INTERNAL]?.[dep.lang];
  };
